import styled from 'styled-components';
export const DialogConsumerContentDefaultBox = styled.div`
    flex-grow: 1;
    padding: 0;
    margin: 0;
    overflow-x: auto;
    overflow-y: auto; 
`;
